export const ONBOARDING_PLAN_PATH = '/onboarding/plan';

export const FIRST_WIN_PATHS = {
  bookings: '/onboarding/booking',
  catalog: '/onboarding/catalog',
  drop: '/onboarding/drop',
} as const;

export type FirstWinValue = keyof typeof FIRST_WIN_PATHS;

export const isFirstWinValue = (value: unknown): value is FirstWinValue =>
  value === 'bookings' || value === 'catalog' || value === 'drop';

export const getOnboardingNextPath = (firstWin: unknown): string => {
  if (isFirstWinValue(firstWin)) {
    return FIRST_WIN_PATHS[firstWin];
  }
  return ONBOARDING_PLAN_PATH;
};

export const getRecommendedPlanId = (firstWin: unknown): 'store' | 'brand' =>
  firstWin === 'catalog' ? 'brand' : 'store';
